import { useQuery } from "@tanstack/react-query";
import classNames from "classnames";
import React from "react";
import { useAppContext } from "../../hooks/useAppContext";

import "./svg-icon.css";

export const SvgIcon = ({
	svgUrl,
	rotated,
	color,
}: {
	svgUrl: string;
	rotated?: boolean;
	color?: string;
}) => {
	const { client, reactQueryNoReloadOptions } = useAppContext();

	const queryResult = useQuery<string>({
		queryKey: [svgUrl],
		queryFn: () => client.getSvgAsync(svgUrl),
		...reactQueryNoReloadOptions,
		meta: {
			logToServer: true,
			errorPrefix: `Error loading SVG icon from ${svgUrl}`,
		},
	});

	const showIconOutline = color && (color === "white" || color === "#ffffff");

	const className = classNames("svg-icon", {
		"svg-icon--rotated": rotated,
		"svg-icon--outline": showIconOutline,
	});

	return queryResult.isSuccess ? (
		<span
			className={className}
			dangerouslySetInnerHTML={{ __html: queryResult.data }}
			style={{ color }}
		/>
	) : null;
};
